import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { STOCK_TYPE } from 'Component/Product/Stock.config';
import { PRODUCT_VARIATIONS_POPUP_ID } from 'Component/ProductVariationsPopup/ProductVariationsPopup.config';
import { CHECKOUT_URL } from 'Route/Checkout/Checkout.config';
import {
    CartItemContainer as SourceCartItemContainer,
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps
} from 'SourceComponent/CartItem/CartItem.container';
import { hideActiveOverlay } from 'Store/Overlay/Overlay.action';
import { showPopup } from 'Store/Popup/Popup.action';
import { TotalsType } from 'Type/MiniCart.type';
import history from 'Util/History';
import { ADD_TO_CART } from 'Util/Product';
import { magentoProductTransform } from 'Util/Product/Transform';

/** @namespace PeggysagePwa/Component/CartItem/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    isCollectInStoreEnabled: state.ConfigReducer.collectinstore_available,
    totals: state.CartReducer.cartTotals
});

/** @namespace PeggysagePwa/Component/CartItem/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    showVariationsPopup: (payload) => dispatch(showPopup(PRODUCT_VARIATIONS_POPUP_ID, payload)),
    hideActiveOverlay: () => dispatch(hideActiveOverlay())
});

/** @namespace PeggysagePwa/Component/CartItem/Container */
export class CartItemContainer extends SourceCartItemContainer {
    static propTypes = {
        ...SourceCartItemContainer.propTypes,
        isCollectInStoreEnabled: PropTypes.number.isRequired,
        totals: TotalsType.isRequired,
        showVariationsPopup: PropTypes.func.isRequired,
        hideActiveOverlay: PropTypes.func.isRequired,
        addProduct: PropTypes.func.isRequired
    };

    static defaultProps = {
        ...SourceCartItemContainer.defaultProps
    };

    state = {
        ...this.state,
        isChosenGiftProduct: false
    };

    containerFunctions = {
        ...this.containerFunctions,
        handleChangeProductVariation: this.handleChangeProductVariation.bind(this),
        onProductAddedToWishlist: this.onProductAddedToWishlist.bind(this)
    };

    componentDidMount() {
        this.setStateIsChosenGiftProduct();

        super.componentDidMount();
    }

    setStateIsChosenGiftProduct() {
        const { item: { isFreeproduct, freeProductRuleId }, totals: { gift_products_choices } } = this.props;

        const giftProductsRulesIds = gift_products_choices.map((rule) => rule.rule_id);

        const isChosenGiftProduct = isFreeproduct && freeProductRuleId
            && giftProductsRulesIds.includes(freeProductRuleId);

        this.setState({ isChosenGiftProduct });
    }

    containerProps() {
        const { isCollectInStoreEnabled } = this.props;
        const { isChosenGiftProduct } = this.state;
        const {
            location: {
                pathname
            }
        } = history;

        const isCheckout = pathname.includes(CHECKOUT_URL);

        return {
            ...super.containerProps(),
            isCollectInStoreEnabled: Boolean(isCollectInStoreEnabled),
            isChosenGiftProduct,
            isCheckout
        };
    }

    /**
     * Override: add params for tracking
     * @return {void}
     * @param quantity
     */
    handleChangeQuantity(quantity) {
        this.setState({ isLoading: true }, () => {
            const {
                changeItemQty,
                item,
                item: { id, quantity: itemQuantity = 1 },
                cartId
            } = this.props;

            if (quantity === itemQuantity) {
                this.setState({ isLoading: false });

                return;
            }

            this.hideLoaderAfterPromise(changeItemQty({
                uid: btoa(id),
                quantity,
                cartId,
                item,
                oldQuantity: itemQuantity
            }));
        });
        this.notifyAboutLoadingStateChange(true);
    }

    handleChangeProductVariation() {
        const {
            showVariationsPopup,
            item: {
                product,
                product: {
                    variation_products: variations
                }
            }
        } = this.props;

        const isColorVariation = !variations.filter((variation) => !variation.variation_thumbnail_url).length;

        const title = isColorVariation ? __('All colors') : __('All variations');

        return showVariationsPopup({
            title,
            product,
            variations,
            onClickVariation: this.onSelectVariation.bind(this)
        });
    }

    async onSelectVariation(_e, variation) {
        if (variation && variation.stock_status !== STOCK_TYPE.OUT_OF_STOCK) {
            const {
                hideActiveOverlay,
                cartId,
                addProduct,
                removeProduct,
                // changeItemQty,
                item: {
                    id: item_id,
                    qty = 1,
                    product: {
                        id: product_id
                    }
                }
            } = this.props;

            hideActiveOverlay();

            if (product_id === variation.id) {
                // Click on current variation => do nothing
                return;
            }

            this.setState({ isLoading: true });

            const magentoProduct = magentoProductTransform(ADD_TO_CART, variation, qty);

            try {
                // Add variation with same qty
                await addProduct({
                    products: magentoProduct,
                    cartId,
                    noPopup: true
                });

                // Remove old item
                /* changeItemQty({
                    uid: btoa(item_id),
                    quantity: 0,
                    cartId
                }); */
                await removeProduct(item_id);
            } finally {
                this.setState({ isLoading: false });
                this.notifyAboutLoadingStateChange(true);
            }
        }
    }

    onProductAddedToWishlist() {
        const { showNotification } = this.props;

        showNotification('success', __('Product added to wish-list!'));
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CartItemContainer);
